import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm } from "react-hook-form";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import ButtonAction from "/src/components/UI/Button/Button";
import "./DashboardVariableFormModal.css"
import dashboardService from '../../../services/dashboardService';
import { variableForm } from "../../../dashboardFormType"
import capitalizeFirstLetter from "/src/components/table/utils/CapitalizeFirstLetter";
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import useVariablesBotAvailable from "../../../hooks/useVariablesBotAvailable"
import DashboardVariableFormButtonSection from "./DashboardVariableFormButtonSection"
import DashboardVariableFormMain from "./DashboardVariableFormMain"
import DashboardVariableFormAdvancedSlide from "./DashboardVariableFormAdvancedSlide"
import DashboardVariableFormConditionalsSlide from "./DashboardVariableFormConditionalsSlide"
import useBlocksConditions from "../../../hooks/useBlocksConditions"
import useDashboards from '../../../hooks/useDashboards';

const DashboardVariableFormModal = NiceModal.create(({ dashboardChannel, variable, block_id, bot, postbackAction }) => {
    var dashboard_id = dashboardChannel.dashboard.id;
    const { dashboard, setUpDashboard } = useDashboards(dashboard_id);
    var type = variable ? "update" : "create";
    const formData = variableForm[type];
    const { addVariable, editVariable } = dashboardService;

    const modal = useModal();
    const toast = useToastDispatchContext();

    const { variablesBot } = useVariablesBotAvailable(dashboardChannel.id, bot.id, variable?.bot_variable_id);

    const { onClose } = useModalHelper(modal);

    const hookBlocks = useBlocksConditions(dashboard,variable)
    const isCheckbox = () => { // 
        return variable?.type == 0
    }
    const isInput = () => { // 
        return variable?.type == 1
    }

    const isDropdown = () => {
        return variable?.type == 2
    }
    const isButton = () => {
        return variable?.type == 3;
    }
    const isNumber = () => { // 
        return variable?.type == 4
    }
    const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, formState } = useForm({
        mode: "onChange",
        defaultValues: {
            label: variable?.label,
            type: variable ? variable.type : 0,
            default_value: isInput() || isButton() || isNumber() ? variable.default_value : "",
            information: variable?.information,
            placeholder_format: variable && isDropdown() ? variable.placeholder_format : (variable ? variable.placeholder_format : "The value doesn't match"),
            regex: variable?.regex,
            value_dropdown: isDropdown() ? variable?.placeholder_format : "",
            default_value_checkbox: isCheckbox() ? parseInt(variable.default_value) : 0,
            enable_message_popup: isButton() && variable.regex != null ? true : false,
            message_popup: isButton() && variable.regex != null ? variable.regex : null,
            enable_response_popup: isButton() && variable.placeholder_format != null ? true : false,
            response_popup: isButton() && variable.placeholder_format != null ? variable.placeholder_format : null,
        }
    })

    const onSubmit = async () => {
        let dataToSend = getValues();

        dataToSend.dashboard_block_id = block_id;
        dataToSend.label = dataToSend.label.trim();
        if (variable != null) {
            dataToSend.id = variable.id;
        }
        if (dataToSend.type == 0) { // checkbox
            dataToSend.default_value = dataToSend.default_value_checkbox;
        }
        if (dataToSend.type == 1 && !dataToSend.default_value) {
            dataToSend.default_value = null;
        }
        else if (dataToSend.type == 2) { // dropdowns
            if (variable?.type == 2) { // si la valeur est supprimee par rapport aux reste, on change pour les dashboards partagees qui avaient la valeur
                let nbChoice = dataToSend.value_dropdown.split("|").length - 1;
                dataToSend.default_value_dropdown = parseInt(dataToSend.default_value_dropdown) > nbChoice ? 0 : dataToSend.default_value_dropdown;
                dataToSend.value = variable?.value < nbChoice ? variable.value : 0;

            }
            dataToSend.placeholder_format = dataToSend.value_dropdown;
            dataToSend.default_value_dropdown = dataToSend.default_value_dropdown == -1 ? 0 : dataToSend.default_value_dropdown;
            dataToSend.default_value = dataToSend.default_value_dropdown;
        }
        else if (dataToSend.type == 3) { // for the button the regex is the confirmation popup et the placeholder format is the result popup, if once is not empty, mean the checkbox is true
            dataToSend.placeholder_format = dataToSend.enable_response_popup == true ? (dataToSend.response_popup != null ? dataToSend.response_popup : "") : null;
            dataToSend.regex = dataToSend.enable_message_popup == true ? (dataToSend.message_popup != null ? dataToSend.message_popup : "") : null;
            dataToSend.bot_variable_id = null;
        }
        else if (dataToSend.type == 4) { // for the number, we just have to set the default value
            dataToSend.default_value = dataToSend.default_value_number;
        }

        dataToSend.conditions = hookBlocks.listBlockConditions;
 
        const [response, errors] = type == "create" ? await addVariable(dataToSend) : await editVariable(variable.id, dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        modal.resolve(response)
        toast.success('Variable ' + (variable ? " edited" : " added"), 'The variable " ' + response.label + ' " has been ' + (variable ? "edited !" : "added ! "));
        postbackAction(response);
        onClose();
    };

    return (
        <Modal name="change-password" id={modal.id} onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            {variablesBot && variablesBot.length > 0 || variable?.type == 3 ?
                <Form className={"container_dashbord_form_variable " + (watch("type") == 2 ? "dashboard_dropdown_form" : watch("type") == 3 ? "dashboard_button_form" : "")} onSubmit={handleSubmit(onSubmit)}>

                    <Form.Title>
                        {formData.title}
                    </Form.Title>

                    <Form.Body className={"form_center_dashboard_variable_form"}>

                        <Slider>
                            <Slide name="obligatory">
                                <DashboardVariableFormMain setValue={setValue} watch={watch} register={register} variable={variable} variablesBot={variablesBot} getValues={getValues} />
                            </Slide>
                            {
                                watch('type') == 3 &&

                                <Slide name="button_result">
                                    <DashboardVariableFormButtonSection setValue={setValue} watch={watch} register={register} getValues={getValues} />
                                </Slide>
                            }
                            <Slide name="advanced">
                                <DashboardVariableFormAdvancedSlide watch={watch} register={register} />
                            </Slide>
                            <Slide name="conditionals" className={"conditionnal_slide_dashboard_variable slider_dashboard_variable_form"}>
                                <DashboardVariableFormConditionalsSlide dashboard_id={dashboard_id} watch={watch} variable={variable} hookBlocks={hookBlocks} />
                            </Slide>
                        </Slider>
                    </Form.Body>
                    <Form.Buttons>
                        <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                        <ButtonAction className="validate" label={formData.send} type="submit" disabled={!formState.isValid} />
                    </Form.Buttons>

                </Form>
                :
                <div className="no_variable"> The bot  &nbsp; <span className="title_bot"> {capitalizeFirstLetter(bot.name)} </span> &nbsp; doesn't have any variable, you can't manage anything</div>

            }
        </Modal>
    )
});

export default DashboardVariableFormModal;